// @flow

const _toggleLike = (comment: Comment, id: number): Comment => {
  const commentCopy = JSON.parse(JSON.stringify(comment))

  if (comment.id === id) {
    commentCopy.isLiked = !comment.isLiked
  }

  if (comment.children && comment.children.length > 0) {
    commentCopy.children = comment.children.map(child => {
      return _toggleLike(child, id)
    })
  }

  // @TODO better way to do this...
  if (comment.userAdded && comment.userAdded.length > 0) {
    commentCopy.userAdded = comment.userAdded.map(child => {
      return _toggleLike(child, id)
    })
  }

  return commentCopy
}

// @TODO use spread like in SET_USER in all other places
export default {
  setCommentable(
    state: CommentsState,
    { commentableType = '', commentableId = -1 }: $Shape<CommentsState>,
  ) {
    state.commentableType = commentableType
    state.commentableId = commentableId
  },

  setCommentsLoading(
    state: CommentsState,
    opts: { status?: boolean, amount?: number, parent?: number } = {},
  ) {
    const { status = true, amount = 1, parent = -1 } = opts
    // if true then displayed or false for hidden
    state.commentsLoading.status = status
    // number of comments to load, used for pagination loader vs first time loader
    state.commentsLoading.amount = amount
    // if loading children replies, the parent.
    state.commentsLoading.parent = parent
  },

  openCommentForm(state: CommentsState, id: number = -1) {
    state.commentForm.active = true
    state.commentForm.id = id
  },

  closeCommentForm(state: CommentsState) {
    state.commentForm.active = false
    state.commentForm.id = -1
  },

  replaceComments(state: CommentsState, newComments: Array<Comment>) {
    state.comments = newComments
  },

  addComments(state: CommentsState, newComments: Array<Comment>) {
    const { commentsLoading, comments } = state

    if (commentsLoading.parent > 0) {
      const parent = comments.find(comment => comment.id === commentsLoading.parent) || {}
      parent.children = parent.children.concat(newComments)
    } else {
      // remove any new comments that already exist (will happen if a new comment
      // was added by another user after original comments were loaded)
      const uniqueNewComments = newComments.filter(
        comment => state.comments.map(c => c.id).indexOf(comment.id) < 0,
      )
      state.comments = comments.concat(uniqueNewComments)
    }
  },

  addComment(state: CommentsState, comment: Comment) {
    const id = state.commentsLoading.parent

    if (id < 0) {
      state.comments = [comment].concat(state.comments)
    } else {
      state.comments = state.comments.map((parentComment: Comment) => {
        if (id === parentComment.id) {
          parentComment.userAdded = parentComment.userAdded || []
          parentComment.userAdded = parentComment.userAdded.concat([comment])
        }
        return parentComment
      })
    }
  },

  // mutate existing comment
  editComment(state: CommentsState, comment: Comment) {
    // default to top level comments
    let parentComment = state.comments

    // if parent, restrict searching to children / userAdded
    if (comment.parentId) {
      const parent = state.comments.find(c => c.id === comment.parentId)

      if (parent && parent.children) {
        parentComment = parent.children

        // add userAdded to get the full list of possible comments
        if (parent.userAdded) {
          parentComment = parentComment.concat(parent.userAdded)
        }
      }
    }
    // end if parent

    const foundComment = parentComment.find(c => c.id === comment.id)

    // only update comment / image / isEdited, keep other attributes as is
    if (foundComment) {
      foundComment.comment = comment.comment
      foundComment.isEdited = true
      foundComment.imageUrl = comment.imageUrl
      foundComment.imageError = comment.imageError
    }
  },

  setCommentTotal(state: CommentsState, n: number = 0) {
    state.totalComments = n
  },

  increaseCommentsTotal(state: CommentsState, n: number = 1) {
    state.totalComments += n
  },

  decreaseCommentsTotal(state: CommentsState, n: number = 1) {
    state.totalComments -= n
  },

  setCommentSort(state: CommentsState, sort: string) {
    state.commentSort = sort
  },

  toggleCommentOptions(state: CommentsState, id: number) {
    state.commentOptions.id = state.commentOptions.id === id ? -1 : id
  },

  toggleCommentLike(state: CommentsState, id: number) {
    state.comments = state.comments.map(comment => {
      return _toggleLike(comment, id)
    })
  },

  increaseCommentLikeCount(state: CommentsState, id: number) {
    state.comments.map(c => {
      if (c.id !== id && c.children.length > 0) {
        c.children.map(ch => {
          ch.id === id && ch.likeCount++
          return ch
        })
      }

      // @TODO better way to do this...
      if (c.id !== id && c.userAdded.length > 0) {
        c.userAdded.map(ua => {
          ua.id === id && ua.likeCount++
          return ua
        })
      }

      c.id === id && c.likeCount++
      return c
    })
  },

  decreaseCommentLikeCount(state: CommentsState, id: number) {
    state.comments.map(c => {
      if (c.id !== id && c.children.length > 0) {
        c.children.map(ch => {
          ch.id === id && ch.likeCount--
          return ch
        })
      }

      // @TODO better way to do this...
      if (c.id !== id && c.userAdded.length > 0) {
        c.userAdded.map(ua => {
          ua.id === id && ua.likeCount--
          return ua
        })
      }

      c.id === id && c.likeCount--
      return c
    })
  },
}
